/** Freeze the shared report's logical CSS geometry, before any page or screen scaling.
 * getBoundingClientRect includes screen zoom; computed dimensions do not.
 */
export function preserveReportCanvas(root: HTMLElement, paired: Map<HTMLElement, HTMLElement>) {
  const canvas = root.querySelector<HTMLElement>('[data-lens-report-canvas]');
  if (!canvas) return;
  const view = root.ownerDocument.defaultView!;
  for (const source of [canvas, ...Array.from(canvas.querySelectorAll<HTMLElement>('*'))]) {
    const copy = paired.get(source);
    if (!copy || (!copy.isConnected && !copy.parentElement)) continue;
    const style = view.getComputedStyle(source);
    if (style.display === 'none') continue;
    // Tables retain their explicitly labelled row-preview policy rather than frozen scroll heights.
    if (source.closest('table, .lp-table-scroll')) continue;
    for (const dimension of ['width', 'height'] as const) {
      if (dimension === 'height' && source.querySelector('table')) continue;
      const value = style[dimension];
      if (/^\d+(?:\.\d+)?px$/.test(value) && parseFloat(value) > 0) {
        copy.style[dimension] = value;
        copy.style.setProperty(`min-${dimension}`, value);
        copy.style.setProperty(`max-${dimension}`, value);
      }
    }
    for (const property of ['grid-template-columns', 'grid-template-rows', 'align-content', 'flex-shrink']) {
      if (property === 'grid-template-rows' && source.querySelector('table')) continue;
      copy.style.setProperty(property, style.getPropertyValue(property));
    }
    copy.style.removeProperty('zoom');
  }
  const clone = paired.get(root);
  if (clone) Object.assign(clone.style, { width: '1600px', minWidth: '1600px', maxWidth: '1600px' });
}
